(function () {
  'use strict';
  if (window.sgBfOffers) { window.sgBfOffers.scan(document); return; }
  var instances = new Map(), active = null;
  function finish(state, restoreFocus) {
    if (!state || state.finished) return;
    state.finished = true;
    document.body.style.overflow = state.overflow;
    document.body.style.paddingRight = state.padding;
    if (active === state) active = null;
    if (restoreFocus && state.trigger && state.trigger.isConnected) state.trigger.focus({ preventScroll: true });
  }
  function close(restoreFocus) {
    if (!active) return;
    var state = active; finish(state, restoreFocus);
    if (state.dialog.open) state.dialog.close();
  }
  function prepare(dialog) {
    if (dialog.dataset.prepared === 'true') return;
    var template = dialog.querySelector('[data-sg-offers-content]');
    var parsed = new DOMParser().parseFromString(template.content.textContent || '', 'text/html');
    parsed.querySelectorAll('script,style,iframe,object,embed,base,meta,link,form,svg,math,template,input,button,textarea,select').forEach(function (node) { node.remove(); });
    parsed.body.querySelectorAll('*').forEach(function (node) {
      Array.from(node.attributes).forEach(function (attribute) {
        var name = attribute.name.toLowerCase(), value = attribute.value.trim();
        if (name.indexOf('on') === 0 || name === 'srcdoc' || name === 'autofocus' || name === 'style' || name === 'contenteditable') node.removeAttribute(attribute.name);
        if (name === 'href' || name === 'src' || name === 'xlink:href' || name === 'action') {
          try { var url = new URL(value, location.href); if (!['http:', 'https:', 'mailto:', 'tel:'].includes(url.protocol)) node.removeAttribute(attribute.name); }
          catch (_) { node.removeAttribute(attribute.name); }
        }
      });
      if (node.tagName === 'A' && node.target === '_blank') node.rel = 'noopener noreferrer';
    });
    var body = dialog.querySelector('[data-sg-offers-body]');
    while (parsed.body.firstChild) body.appendChild(parsed.body.firstChild);
    dialog.dataset.prepared = 'true';
  }
  function offset() {
    var bottom = 0;
    document.querySelectorAll('sticky-header,.shopify-section-header-sticky .header-wrapper,[data-sg-anchor-nav],[data-sticky-header],.shopify-section-group-header-group').forEach(function (node) {
      var rect = node.getBoundingClientRect(), style = getComputedStyle(node);
      if ((style.position === 'fixed' || style.position === 'sticky' || node.classList.contains('is-pinned')) && rect.height && rect.bottom > 0 && rect.top < 160) bottom = Math.max(bottom, rect.bottom);
    });
    var nav = document.querySelector('[data-sg-anchor-shell][data-sticky="true"] [data-sg-anchor-nav]');
    if (nav && !nav.classList.contains('is-pinned')) bottom += nav.getBoundingClientRect().height;
    return bottom + 16;
  }
  function init(root) {
    if (instances.has(root)) return;
    var form = root.querySelector('[data-sg-offers-form]'), submit = form && form.querySelector('[data-sg-offers-submit]');
    var pending = false, focused = false, focusFrame = 0;
    function resetPending() {
      pending = false;
      if (submit) { submit.removeAttribute('aria-disabled'); submit.removeAttribute('aria-busy'); submit.textContent = submit.dataset.label; }
      var status = root.querySelector('[data-sg-offers-form-status]'); if (status) status.textContent = '';
    }
    function vipAnchor() { return root.querySelector('[data-sg-vip-anchor]') || root; }
    function sourceMatches() { return new URL(location.href).searchParams.get('sg_vip_form') === root.dataset.sectionId || location.hash === '#'+(form && form.id) || location.hash === '#' + vipAnchor().id || location.hash === '#' + vipAnchor().dataset.sgAnchorDefault; }
    function focusResult() {
      if (focused || !sourceMatches()) return;
      var result = root.querySelector('[data-sg-offers-errors]') || root.querySelector('[data-sg-offers-success]');
      if (result) { result.focus({ preventScroll: true }); focused = document.activeElement === result; var top = vipAnchor().getBoundingClientRect().top + scrollY - offset(); window.scrollTo({ top: Math.max(0, top), behavior: 'auto' }); }
    }
    function scheduleResultFocus() {
      cancelAnimationFrame(focusFrame);
      focusFrame = requestAnimationFrame(function () { focusFrame = requestAnimationFrame(focusResult); });
    }
    function returnTarget() {
      if (!form) return;
      var field = form.querySelector('input[name="return_to"]');
      if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = 'return_to'; form.appendChild(field); }
      var url = new URL(location.href); url.searchParams.delete('contact_posted'); url.searchParams.delete('customer_posted'); url.searchParams.delete('form_type');
      url.searchParams.set('sg_vip_form', root.dataset.sectionId);
      field.value = url.pathname + url.search + '#' + vipAnchor().id;
    }
    function onSubmit(event) {
      if (pending) { event.preventDefault(); return; }
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      returnTarget(); pending = true;
      if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.setAttribute('aria-busy', 'true'); submit.textContent = 'Submitting…'; }
      var status = root.querySelector('[data-sg-offers-form-status]'); if (status) status.textContent = 'Submitting your email registration…';
      // Keep native serialization, Shopify validation and challenge handling intact.
    }
    function pageshow() { resetPending(); focused = false; scheduleResultFocus(); }
    function show(dialog, trigger) {
      if (typeof dialog.showModal !== 'function') return false;
      close(false); prepare(dialog);
      var state = { dialog: dialog, trigger: trigger, overflow: document.body.style.overflow, padding: document.body.style.paddingRight, finished: false };
      var scrollbar = innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar) + 'px';
      active = state;
      try { dialog.showModal(); dialog.querySelector('[data-sg-offers-close]').focus(); }
      catch (_) { finish(state, true); return false; }
      return true;
    }
    function click(event) {
      var opener = event.target.closest('[data-sg-offers-open]');
      if (opener && root.contains(opener)) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var dialog = document.getElementById(opener.dataset.sgOffersOpen);
        if (dialog && root.contains(dialog) && show(dialog, opener)) event.preventDefault();
        return;
      }
      if (event.target.closest('[data-sg-offers-close]')) { close(true); return; }
      if (event.target.matches('[data-sg-offers-dialog]')) {
        var box = event.target.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(true);
        return;
      }
      var link = event.target.closest('[data-sg-offers-anchor]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var url = new URL(link.href, location.href);
      if (!url.hash || url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
      var target; try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { return; }
      if (!target) return;
      event.preventDefault();
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + scrollY - offset()), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.pushState(null, '', url.hash);
      var focus = target.querySelector('h1,h2,h3') || target, previous = focus.getAttribute('tabindex');
      focus.setAttribute('tabindex', '-1'); focus.focus({ preventScroll: true });
      if (previous === null) focus.addEventListener('blur', function () { focus.removeAttribute('tabindex'); }, { once: true });
    }
    function keydown(event) {
      if (!active || !root.contains(active.dialog)) return;
      if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
      if (event.key !== 'Tab') return;
      var targets = Array.from(active.dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (node) { return node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'; });
      var first = targets[0], last = targets[targets.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && (document.activeElement === first || !active.dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    var cleanupDialogs = [];
    root.querySelectorAll('[data-sg-offers-dialog]').forEach(function (dialog) {
      function cancel(event) { event.preventDefault(); if (active && active.dialog === dialog) close(true); }
      function closed() { if (active && active.dialog === dialog) finish(active, true); }
      dialog.addEventListener('cancel', cancel); dialog.addEventListener('close', closed);
      cleanupDialogs.push(function () { dialog.removeEventListener('cancel', cancel); dialog.removeEventListener('close', closed); });
    });
    root.addEventListener('click', click); root.addEventListener('keydown', keydown);
    if (form) form.addEventListener('submit', onSubmit);
    window.addEventListener('pageshow', pageshow);
    root.addEventListener('sg:anchor:updated', returnTarget);
    returnTarget(); resetPending();
    // Initial fragment navigation can override an early focus. Wait until the
    // completed page (or pageshow) and the next painted frames before focusing.
    if (document.readyState === 'complete') scheduleResultFocus();
    if (root.querySelector('[data-sg-email-registration-success]')) {
      if (window.sgBfMemberDisplay) window.sgBfMemberDisplay.scan(root);
      else window.dispatchEvent(new CustomEvent('sg:member-native-source-ready'));
    }
    instances.set(root, function () { root.removeEventListener('sg:anchor:updated', returnTarget); cancelAnimationFrame(focusFrame); if (active && root.contains(active.dialog)) close(false); cleanupDialogs.forEach(function (cleanup) { cleanup(); }); root.removeEventListener('click', click); root.removeEventListener('keydown', keydown); if (form) form.removeEventListener('submit', onSubmit); window.removeEventListener('pageshow', pageshow); });
  }
  function scan(scope) { if (scope.matches && scope.matches('[data-sg-offers]')) init(scope); scope.querySelectorAll('[data-sg-offers]').forEach(init); }
  window.sgBfOffers = { scan: scan, destroy: function (root) { if (instances.has(root)) { instances.get(root)(); instances.delete(root); } }, instanceCount: function () { return instances.size; } };
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { instances.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); instances.delete(root); } }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }); else scan(document);
})();
